"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlumTreeRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const empty_1 = require("../../../generated/google/protobuf/empty");
class PlumTreeRpcLocal {
    neighbors;
    pausedNodes;
    onMetadataCb;
    sendBuffer;
    constructor(neighbors, pausedNodes, onMetaDataCb, sendBuffer) {
        this.neighbors = neighbors;
        this.pausedNodes = pausedNodes;
        this.onMetadataCb = onMetaDataCb;
        this.sendBuffer = sendBuffer;
    }
    async sendMetadata(message, context) {
        const previousNode = context.incomingSourceDescriptor;
        await this.onMetadataCb(message, previousNode);
        return empty_1.Empty;
    }
    async pauseNeighbor(request, context) {
        const sender = (0, dht_1.toNodeId)(context.incomingSourceDescriptor);
        if (this.neighbors.has(sender)) {
            this.pausedNodes.add(sender, request.messageChainId);
        }
        return empty_1.Empty;
    }
    async resumeNeighbor(request, context) {
        const sender = context.incomingSourceDescriptor;
        this.pausedNodes.delete((0, dht_1.toNodeId)(sender), request.messageChainId);
        await this.sendBuffer(request.fromTimestamp, request.messageChainId, sender);
        return empty_1.Empty;
    }
}
exports.PlumTreeRpcLocal = PlumTreeRpcLocal;
//# sourceMappingURL=PlumTreeRpcLocal.js.map